// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tWMI","index":"styles_index__2W4Fy"};